import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardLayout from '../../layouts/dashboard';
import { VehiclesEdit } from '../../../components/Vehicles/VehiclesEdit';

export const VehiclesEditPage = () => {
  return (
    <DashboardLayout title={'Unidades'}>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ minHeight: '100vh' }}
      >
        <Grid item xs>
          <VehiclesEdit />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};
